import { Component } from '@angular/core';

@Component({
    selector: 'app-feature',
    templateUrl: './feature.component.html',
    styleUrls: ['./feature.component.scss'],
    standalone: false
})
export class FeatureComponent {
  items = [
    {
      img: './assets/images/featured/feature_1.svg',
    },
    {
      img: './assets/images/featured/feature_2.svg',
    },
    {
      img: './assets/images/featured/feature_3.svg',
    },
    {
      img: './assets/images/featured/feature_4.svg',
    },
    {
      img: './assets/images/featured/feature_5.svg',
    },
    {
      img: './assets/images/featured/feature_6.svg',
    },
    {
      img: './assets/images/featured/feature_7.svg',
    },
    {
      img: './assets/images/featured/feature_8.svg',
    },
    {
      img: './assets/images/featured/feature_9.svg',
    },
    {
      img: './assets/images/featured/feature_10.svg',
    },
  ];
}
